var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" "+_vm._s(_vm.$t(("active_delivery_method." + (_vm.job.primaryDeliveryMethod))))+" "),_c('v-icon',{attrs:{"color":_vm.color}},[_vm._v("location_on")]),_vm._v(" "+_vm._s(_vm.status)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }